const ContactHelp = () => {
  const contactStage = [
    {
      title: "Idea Stage",
      description:
        "Validate your concept with data-driven insights. Build a business model and MVP roadmap.",
      href: "/idea-stage",
    },
    {
      title: "Valley Of Death Stage",
      description:
        "Navigate funding and operational challenges. Develop strategies to sustain and grow.",
      href: "/valley-stage",
    },
    {
      title: "Growth Stage",
      description:
        "Scale confidently with optimized processes. Unlock growth opportunities and prepare for expansion.",
      href: "/growth-stage",
    },
  ];
  return (
    <div id="contact-help-container">
      <div className="contact-help-title">How we can help you?</div>
      <div className="contact-help-desc">
        We offer tailored support across all stages of the startup lifecycle
      </div>
      <div className="contact-stage-container">
        {contactStage.map((stage, index) => (
          <div className="contact-stage-innercontainer" key={index}>
            <div>
              <div className="contact-stage-title">{stage.title}</div>
              <div className="contact-stage-desc">{stage.description}</div>
            </div>
            <div className="contact-stage-href">
              <a href={stage.href}>Know more</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactHelp;
